import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React from 'react'

import {i18n} from '../../config'

function ConnectionMethodsMenu(): React.ReactElement {
  return (
    <Grid direction="column" container>
      <Grid item>
        <HeaderButton
          href="https://passport.yandex.ru/auth/reg?retpath=https%3A%2F%2Fdostavka.yandex.ru%2Faccount2%3Foffer%3Dtrue&origin=dostavka"
          size="s"
          target="_blank"
          variant="pseudo"
          transparent
        >
          {i18n('order.header.link.personal-area', 'Личный кабинет')}
        </HeaderButton>
      </Grid>
      <Grid item>
        <HeaderButton href="/business/small/" size="s" variant="pseudo" transparent>
          {i18n('order.header.link.yandex-go-application', 'Приложение Яндекс Go')}
        </HeaderButton>
      </Grid>
      <Grid item>
        <HeaderButton href="/integrations/api/" size="s" variant="pseudo" transparent>
          {i18n('order.header.link.api-integration', 'API-интеграция')}
        </HeaderButton>
      </Grid>
      <Grid item>
        <HeaderButton href="/integrations/restaurants/" size="s" variant="pseudo" transparent>
          {i18n('order.header.link.restaurant-modules', 'Модули для ресторанов')}
        </HeaderButton>
      </Grid>
      <Grid item>
        <HeaderButton href="/integrations/ecommerce/" size="s" variant="pseudo" transparent>
          {i18n('order.header.link.internet-shop-modules', 'Модули для интернет-магазинов')}
        </HeaderButton>
      </Grid>
    </Grid>
  )
}

export default ConnectionMethodsMenu
